import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  approve: {
    backgroundColor: theme.palette.success.main,
  },
  reject: {
    backgroundColor: theme.palette.error.main,
  },
}));

export default useStyles;
